import React, { useMemo } from 'react';
import CheckoutSection from './utils/Checkout.Section';
import CheckoutSectionContent from './utils/Checkout.SectionContent';
import { translate } from '../../Services/translation';
import styled from 'styled-components';
import { breakpoint } from '../../styling/mixins/breakpoints';
import { cells } from '../../styling/utils/grid';
import { getColor } from '../../styling/mixins/colors';
import { fontFamilyBold, text } from '../../styling/mixins/typography';
import Dropdown from '../Dropdown';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { useDispatch } from 'react-redux';
import {
  setSelectedDeliveryAddress,
  setSelectedBillingAddress,
} from '../../Actions/Checkout.action';
declare var LitiumConstants: any;

const getCountry = (address) => {
  const addressCountry = LitiumConstants.countries && address?.country
    ? LitiumConstants.countries.find(
      (country) => country && country.value === address.country
    )
    : null;
  return addressCountry ? addressCountry.text : address?.country;
};

const StyledCheckoutSectionContent = styled(CheckoutSectionContent)`
  display: grid;
  gap: 1.6rem;

  ${breakpoint('medium')} {
    ${cells(2)}
  }
`;

const StyledCheckoutInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  .wrapper-title {
    ${text('xlarge')}
    ${fontFamilyBold}
  }
`;

const StyledCheckoutInfoContainer = styled.div`
  background-color: ${getColor('grey', 100)};
  border-radius: 4px;
  padding: 1.6rem;
  display: flex;
  gap: 0.8rem;
  flex: 1;

  .container-text {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }

  .container-title {
    ${text('xlarge')}
    ${fontFamilyBold}
  }
`;

const StyledCheckoutDropdown = styled(Dropdown)`
  margin-bottom: 0.8rem;

  .dropdown-select {
    background-color: ${getColor('grey', 100)};
  }
`;

const BusinessCustomerInfo = () => {
  const dispatch = useDispatch();
  const { payload } = useTypedSelector((state) => state.checkout);
  const addressList = useMemo(
    () =>
      payload.companyAddresses.filter((type) => type.addressType !== 'Billing'),
    [payload.companyAddresses]
  );
  const billingList = useMemo(
    () =>
      payload.companyAddresses.filter((type) => type.addressType == 'Billing'),
    [payload.companyAddresses]
  );
  const selectedDeliveryAddress = useMemo(
    () =>
      addressList.find((a) => a.systemId == payload.selectedDeliveryAddressId),
    [addressList, payload.selectedDeliveryAddressId]
  );
  const selectedBillingAddress = useMemo(
    () =>
      billingList.find((a) => a.systemId == payload.selectedBillingAddressId),
    [billingList, payload.selectedBillingAddressId]
  );

  return (
    <CheckoutSection title={translate('checkout.customerinfo.title')}>
      <StyledCheckoutSectionContent>
        <StyledCheckoutInfoWrapper>
          <div className="wrapper-title">
            {translate('checkout.selectdelivery')}
          </div>
          <StyledCheckoutDropdown
            placeholder={translate('checkout.selectdelivery')}
            selectedValue={payload.selectedDeliveryAddressId}
            options={addressList.map((address) => ({
              value: address.systemId,
              label: `${payload.companyName}, ${address.address}, ${address.city}, ${address.zipCode}, ${getCountry(address)}`,
            }))}
            onChange={({ value }) => {
              dispatch(setSelectedDeliveryAddress(value));
            }}
            disabled={addressList.length <= 1}
          />
          <StyledCheckoutInfoContainer>
            <div className="container-text">
              <span className="container-title">{translate('checkout.order.delivery')}</span>
              <span className="container-span">
                {selectedDeliveryAddress ? payload.companyName : translate('checkout.no.delivery.address')}
              </span>
              <span className="container-span">
                {selectedDeliveryAddress?.address}
              </span>
              <span className="container-span">
                {selectedDeliveryAddress?.zipCode}{' '}
                {selectedDeliveryAddress?.city}
              </span>
              <span className="container-span">
                {getCountry(selectedDeliveryAddress)}
              </span>
            </div>
          </StyledCheckoutInfoContainer>
        </StyledCheckoutInfoWrapper>
        <StyledCheckoutInfoWrapper>
          <div className="wrapper-title">
            {translate('checkout.selectbilling')}
          </div>
          <StyledCheckoutDropdown
            placeholder={translate('checkout.selectbilling')}
            selectedValue={payload.selectedBillingAddressId}
            options={billingList.map((address) => ({
              value: address.systemId,
              label: `${payload.companyName}, ${address.address}, ${address.city}, ${address.zipCode}, ${getCountry(address)}`,
            }))}
            onChange={({ value }) => setSelectedBillingAddress(value)}
            disabled={true}
          />
          <StyledCheckoutInfoContainer>
            <div className="container-text">
              <span className="container-title">{translate('checkout.order.billing')}</span>
              <span className="container-span">
                {payload.companyName}
              </span>
              <span className="container-span">
                {selectedBillingAddress?.address}
              </span>
              <span className="container-span">
                {selectedBillingAddress?.zipCode} {selectedBillingAddress?.city}
              </span>
              <span className="container-span">
                {getCountry(selectedBillingAddress)}
              </span>
            </div>
          </StyledCheckoutInfoContainer>
        </StyledCheckoutInfoWrapper>
      </StyledCheckoutSectionContent>
    </CheckoutSection>
  );
};

export default BusinessCustomerInfo;
